// Re-export all functions from the files
export * from './strings';
// Datadog is the raw vendor boundary; only its composition API is public here.
// `logDatadogError` and the internal ignore-list predicates are intentionally
// not re-exported -- report errors through the observability facade instead.
export {
  initializeDatadog,
  identifyDatadogUser,
  DEFAULT_SESSION_REPLAY_SAMPLE_RATE,
  MAX_SESSION_REPLAY_SAMPLE_RATE,
} from './datadog';
export type { DatadogServiceConfig } from './datadog';
export * from './candidateAvailabilityUtils';

// Re-export individual functions from the files.
export { logError } from './logError';
export { logMessage } from './logMessage';
export { default as axiosRetry } from './axios/axiosRetry';
export { default as axioxInterceptorMlTraceId } from './axios/axioxInterceptorMlTraceId';
export { default as axiosInterceptorResponseError } from './axios/axiosInterceptorResponseError';
export {
  getErrorStatus,
  getErrorMessageForReason,
  getExternalErrorMessage,
  getInternalErrorMessage,
  isPermissionsError,
} from './axios/error';
export { encode, decode } from './encodeDecode';
export { getVideoUrlType, isValidVideoUrl, normalizeVideoEmbedUrl, VIDEO_URL_TYPE } from './videoUtils';
export type { VideoUrlType } from './videoUtils';
export { getPickerIcon } from '../components/IconPicker/Icons/utils';
export { sha256Encode } from './sha256';

export { constructCustomTheme } from './brandingThemes';

export const inIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export {
  mergeTimeRanges,
  getTimeRangesInTimezone,
  getUniqueTimeRanges,
  sortTimeRanges,
  getTimePeriods,
  isTimeBlockWeekNotEmpty,
  DEFAULT_WORK_HOURS,
} from './timeRangeUtils';
export type { TimeRange } from './types';
export type { TimeBlockWeek } from './timeRangeUtils';
export { plainText, snakeCaseToInitCase, snakeCaseToCapitalize } from './plainText';

export { default as copyRichTextToClipboard } from './copyRichTextToClipboard';

export { fetchImage } from './fetchImage';
export { getFileSizeString } from '../components/ImageUpload/utils';

export { default as isValidHttpUrl } from './isValidHttpUrl';

export { getValidatedUrl } from './getValidatedUrl';

export { default as isValidEmail } from './isValidEmail';

export { PreventOverflowPopperProps } from './preventTooltipOverflow';

export { default as LocalStorageUtil } from './localStorageUtil';
export { installStaleDeployReloadHandler, isStaleDeployError, reloadForStaleDeploy } from './staleDeploy';
export { concurrencyLimitFromFlag, createConcurrencyLimiter, runWithConcurrencyLimit } from './promisePool';
